import { combineReducers, combineSlices } from "@reduxjs/toolkit";
import { allReportReducers } from "@sscs/report/store";
import { baseApi } from "Services";
import authReducer from "./auth.slice";
import projectsReducer from "./projects.slice";
import reportsReducer from "./reports.slice";

// https://redux-toolkit.js.org/api/combineSlices#withlazyloadedslices
export interface LazyLoadedSlices {}

export const rootReducer = combineSlices(baseApi, {
  auth: authReducer,
  projects: projectsReducer,
  report: combineReducers(allReportReducers),
  reports: reportsReducer,
  [baseApi.reducerPath]: baseApi.reducer,
}).withLazyLoadedSlices<LazyLoadedSlices>();

export type RootState = ReturnType<typeof rootReducer>;
